<div class="consult-table-empty-state" role="status" aria-live="polite">
  <div class="consult-table-empty-state__content">
    <div class="consult-table-empty-state__icon-wrap" aria-hidden="true">
      <b3-icon [name]="icon" size="lg"></b3-icon>
    </div>
    <h2 class="consult-table-empty-state__title">{{ title }}</h2>
    <p class="consult-table-empty-state__description">{{ description }}</p>
  </div>
</div>
